import { createElement } from './globalFunctions'
const language = dataLayer[0].shoptet.language

/**
 * Add a title to the filters boolean section
 *
 * @param {string} title - The title to be added to the filters boolean section
 */
const addTitleToFiltersBoolean = (title) => {
	const filtersBoolean = document.querySelector('.filter-section-boolean')
	if (filtersBoolean) {
		const help = filtersBoolean.querySelector('h4')
		if (help) return
		const filtersBooleanHeading = createElement('h4', [], title)
		filtersBoolean.prepend(filtersBooleanHeading)
	}
}

/**
 * Make filter titles clickable
 * Adds an event listener to the filter titles that toggles the visibility of the filter form
 * Saves the state of the filter form visibility to the sessionStorage
 * The state is saved as an array of strings with the class names of the filter sections
 * Use `filter-form-visible` class to show the filter form
 */
const makeFilterTitlesClickable = () => {
	const filterSections = document.querySelectorAll('.filter-section')
	for (const section of filterSections) {
		let heading = section.querySelector('h4')
		if (!heading) continue
		heading.addEventListener('click', (e) => {
			e.preventDefault()
			e.stopPropagation()
			section.classList.toggle('filter-form-visible')
			let cache = JSON.parse(window.sessionStorage.getItem('openedFilters')) || [],
				parentClass = e.currentTarget.parentElement.className
			parentClass = parentClass.replace('filter-form-visible', '')
			parentClass = parentClass.trim()
			if (cache.includes(parentClass)) {
				cache = cache.filter((item) => {
					return item !== parentClass
				})
			} else {
				cache.push(parentClass)
			}
			window.sessionStorage.setItem('openedFilters', JSON.stringify(cache))
		})
	}
	const priceFilterCustom = document.querySelector('.slider-wrapper')
	if (priceFilterCustom) {
		priceFilterCustom.querySelector('h4').addEventListener('click', (e) => {
			priceFilterCustom.classList.toggle('filter-form-visible')
			let cache = JSON.parse(window.sessionStorage.getItem('openedFilters')) || [],
				parentClass = e.currentTarget.parentElement.classList[0]
			if (cache.includes(parentClass)) {
				cache = cache.filter((item) => {
					return item !== parentClass
				})
			} else {
				cache.push(parentClass)
			}
			window.sessionStorage.setItem('openedFilters', JSON.stringify(cache))
		})
	}

	let helperCache = window.sessionStorage.getItem('openedFilters')
	if (helperCache) {
		helperCache = JSON.parse(helperCache)
		if (helperCache.length) {
			for (let item of helperCache) {
				item = item.replaceAll(' ', '.')
				item = document.querySelector(`.${item}`)
				if (item) item.classList.add('filter-form-visible')
			}
		}
	}
}

/**
 * Create a button to show subcategories
 * Toggle `show` class on the subcategories element
 * @param {string} text - The text of the button
 */
const createShowSubcategoriesButton = (text) => {
	const subcategories = document.querySelector('.subcategories')
	if (!subcategories) return
	const showCategoriesBtn = createElement('button', ['show-categories', 'btn'], text)
	showCategoriesBtn.addEventListener('click', () => {
		subcategories.classList.toggle('show')
	})
}

// give ID to bottom description of category, so that it can be refered to from top description
const addIDToDescription = () => {
	const secondaryDesc = document.querySelector('.category__secondDescription')
	if (secondaryDesc) secondaryDesc.id = 'secondDescription'
}

/**
 * Move category banners into products section and merges both products sections
 * @param {number} firstBannerPosition - The position of the first banner
 * @param {number} secondBannerPosition - The position of the second banner
 */
const moveCategoryBannersIntoProducts = (firstBannerPosition = 0, secondBannerPosition = 0) => {
	const categoryBanners = document.querySelectorAll('.banner-category')
	if (!categoryBanners.length) return
	const firstProductBlock = document.querySelector('#products')
	const secondProductBlock = document.querySelector('.products-block:not(#products)')
	if (secondProductBlock) {
		const secondBlockProducts = secondProductBlock.querySelectorAll('.product')
		for (const product of secondBlockProducts) {
			if (firstProductBlock) firstProductBlock.appendChild(product)
		}
		secondProductBlock.remove()
	}
	for (const [index, categoryBanner] of categoryBanners.entries()) {
		if (categoryBanner && firstProductBlock) {
			categoryBanner.classList.add('product')
			let whereToAppend = null
			switch (index) {
				case 0:
					whereToAppend = firstProductBlock.querySelector(`.product:nth-child(${firstBannerPosition})`)
					break
				case 1:
					whereToAppend = firstProductBlock.querySelector(`.product:nth-child(${secondBannerPosition})`)
					break
				default:
					whereToAppend = firstProductBlock.querySelector('.product:last-child')
					break
			}
			if (whereToAppend) {
				whereToAppend.after(categoryBanner)
			} else {
				firstProductBlock.appendChild(categoryBanner)
			}
		}
	}
}

const createCategoryWrapper = () => {
	if (document.querySelector('.custom-category-wrapper')) {
		const categoryTopDuplicate = document.querySelector('#content > .category-top')
		if (categoryTopDuplicate) categoryTopDuplicate.remove()
	} else {
		const categoryTop = document.querySelector('.category-top')
		const breadcrumbsWrapper = document.querySelector('.breadcrumbs-wrapper')
		if (categoryTop) {
			categoryTop.classList.add('container')
			const customCategoryWrapper = createElement('div', ['custom-category-wrapper'])
			customCategoryWrapper.append(categoryTop)
			if (breadcrumbsWrapper) breadcrumbsWrapper.after(customCategoryWrapper)
		}
	}
}

const handleTopProducts = () => {
	const productsTop = document.querySelector('#productsTop')
	const contentWrapper = document.querySelector('#content-wrapper')
	if (productsTop) {
		const productsTopHeading = productsTop.previousElementSibling
		if (contentWrapper) {
			contentWrapper.prepend(productsTop)
			if (productsTopHeading) {
				contentWrapper.prepend(productsTopHeading)
				productsTopHeading.classList.add('productsTopHeading')
			}
		}

		const topProductBottoms = productsTop.querySelectorAll('.product .p-bottom > div')
		if (topProductBottoms.length) {
			for (let bottom of topProductBottoms) {
				if (!bottom.querySelector('.p-tools')) {
					const newPTools = document.createElement('div')
					if (
						!bottom.querySelector("div[data-micro-availability='https://schema.org/OutOfStock']") &&
						dataLayer[0].shoptet.customer.registered === true
					) {
						const detailBottom = document.createElement('form')
						detailBottom.innerHTML = `
					
						<input type="hidden" name="language" value="cs">                                                     
						<input type="hidden" name="amount" autocomplete="off" class="">
						<button type="submit" class="btn btn-cart add-to-cart-button"><span>${language === 'cs' ? 'Přidat' : 'Přidať'}</span></button>
						`
						newPTools.classList.add('p-tools')

						const toCart = detailBottom.querySelector('.add-to-cart-button')
						const pCode = bottom.closest('.product').querySelector('span[data-micro="sku"]').textContent.trim()
						if (toCart) {
							toCart.addEventListener('click', (e) => {
								e.preventDefault()
								const inputValue = detailBottom.querySelector('input[name="amount"]').value

								shoptet.cartShared.addToCart({ productCode: pCode, amount: inputValue })
							})
						}
						newPTools.appendChild(detailBottom)
					} else if (!bottom.querySelector('a.btn')) {
						const detailBtn = document.createElement('a')
						detailBtn.classList.add('btn', 'btn-primary')
						detailBtn.href = bottom.closest('.product').querySelector('a.image').href
						detailBtn.innerText = language === 'cs' ? 'Zobrazit detail' : 'Zobraziť detail'
						newPTools.appendChild(detailBtn)
					}

					bottom.appendChild(newPTools)
				}
			}
		}
	}
}

const categoryHead = () => {
	if (!document.querySelector('.custom-category-wrapper')) {
		// const breadcrumbsWrapper = document.querySelector('.breadcrumbs-wrapper')

		// if (header) {
		// const customCategoryWrapper = document.createElement('div')
		// customCategoryWrapper.classList.add('custom-category-wrapper')
		// if (breadcrumbsWrapper) customCategoryWrapper.append(breadcrumbsWrapper)

		const categoryTop = document.querySelector('.category-top')
		let desktopImg
		let mobileImg
		if (categoryTop) {
			const categoryPerex = categoryTop.querySelector('.category-perex')
			if (categoryPerex) {
				const perexImgs = categoryPerex.querySelectorAll('img')
				if (perexImgs.length) {
					categoryTop.classList.add('custom-category-wrapper')

					// setTimeout(() => {
					perexImgs.forEach((img) => {
						if (img.naturalWidth > 800) desktopImg = img.src
						if (img.naturalWidth <= 800) mobileImg = img.src
						img.parentElement.remove()
					})
					// customCategoryWrapper.classList.add('has-category-img')
					// }, 10)
				}
			}
			if (desktopImg !== undefined || mobileImg !== undefined) {
				const categoryHeaderImage = document.createElement('img')
				categoryHeaderImage.classList.add('category-header-image')
				if (window.innerWidth <= 767) categoryHeaderImage.src = mobileImg
				else categoryHeaderImage.src = desktopImg
				categoryTop.append(categoryHeaderImage)
				const catHeading = categoryTop.querySelector('.category-title')
				const headingPlaceholder = categoryTop.querySelector('.h1-placeholder')
				if (catHeading) {
					if (headingPlaceholder) {
						headingPlaceholder.innerHTML = ''
						headingPlaceholder.append(catHeading)
					} else if (categoryPerex) categoryPerex.prepend(catHeading)
				}
			}
			// customCategoryWrapper.prepend(categoryHeaderImage)
			// customCategoryWrapper.append(categoryTop)
			// categoryTop.classList.add('container')
			// header.after(customCategoryWrapper)
			const subcategories = document.querySelector('.subcategories')
			if (subcategories) {
				// const subcategoriesWrapper = document.createElement('div')
				// subcategoriesWrapper.classList.add('custom-category-wrapper')
				categoryTop.after(subcategories)
				const subcatItems = subcategories.querySelectorAll('li')
				if (subcatItems.length > 5 && window.innerWidth < 768) {
					const showMoreBtn = createElement('button', ['show-more-btn'], language === 'cs' ? 'Ukázat více' : 'Zobraziť viac')
					subcategories.after(showMoreBtn)
					showMoreBtn.addEventListener('click', () => {
						subcategories.classList.toggle('show-all')
						showMoreBtn.remove()
					})
				}
				// subcategories.classList.add('container')
			}
		}
		// }
	}
	// else {
	// 	let catTop = document.querySelector('#content .category-top')
	// 	if (catTop) catTop.remove()
	// }
}

const handleCheckedFilters = () => {
	const filterSections = document.querySelector('.filter-sections')
	if (filterSections) {
		const activeFilters =
			filterSections.querySelectorAll('#filters input[type="checkbox"]:checked+label') ||
			document.querySelectorAll('#filters input[type="checkbox"]:checked+label')
		if (activeFilters.length) {
			// const categoryContent = document.querySelector('#content')
			// const categoryContent = document.querySelector('.category-top')
			let activeFiltersWrapper = document.createElement('div'),
				activeFiltersTitle = document.createElement('strong'),
				activeFiltersList = document.createElement('div')
			activeFiltersTitle.classList.add('active-title')
			activeFiltersWrapper.classList.add('active-filters')
			activeFiltersWrapper.appendChild(activeFiltersTitle)
			activeFiltersList.classList.add('active-list')
			activeFiltersWrapper.appendChild(activeFiltersTitle)
			activeFiltersWrapper.appendChild(activeFiltersList)
			activeFiltersTitle.textContent = language === 'cs' ? 'Vybrané filtry: ' : 'Vybrané filtre: '
			activeFilters.forEach((item) => {
				if (item.classList.contains('no-display')) {
					const itemClone = item.cloneNode(true)
					itemClone.classList.remove('no-display')
					activeFiltersList.appendChild(itemClone)
				} else {
					activeFiltersList.appendChild(item.cloneNode(true))
				}
				// const itemSection = item.closest('.filter-section')
				// if (itemSection) {
				// 	const itemSectionTitle = itemSection.querySelector('h4')
				// 	if (itemSectionTitle) {
				// 		const sectionTitle = createElement('div', ['section-title'], itemSectionTitle.textContent)
				// 		activeFiltersList.appendChild(sectionTitle)
				// 	}
				// }
			})
			let deleteFilters = document.querySelector('#clear-filters')
			if (deleteFilters) {
				const deleteFiltersLink = deleteFilters.querySelector('a')
				if (deleteFiltersLink) deleteFiltersLink.textContent = language === 'cs' ? 'Zrušit všechno' : 'Zrušiť všetko'

				// deleteFilters.textContent = 'Zrušit všechny filtry'
				// const deleteClone = deleteFilters.cloneNode(true)
				activeFiltersWrapper.appendChild(deleteFilters)
				// deleteFilters.addEventListener('click', () => {
				// 	$(deleteFilters).click()
				// })
			}
			if (filterSections.querySelector('.active-filters')) filterSections.querySelector('.active-filters').remove()
			const filtersWrapper = document.querySelector('#filters-wrapper')
			const otherCategory = document.querySelector('.other-category-wrapper')
			if (filtersWrapper) filtersWrapper.append(activeFiltersWrapper)
			// filterSections.appendChild(activeFiltersWrapper)
			// if (otherCategory) {
			// 	otherCategory.prepend(activeFiltersWrapper)
			// } else {
			// 	filtersWrapper.parentElement.insertBefore(activeFiltersWrapper, filtersWrapper.nextElementSibling)
			// }

			// filterSections.appendChild(activeFiltersWrapper)
		}
	}
}

const handleTotalProductCount = () => {
	const totalProductCount = document.querySelector('#category-header > div')
	if (!totalProductCount) return
	totalProductCount.classList.add('total-product-count')
	const totalCountStrong = totalProductCount.querySelector('strong')
	if (!totalCountStrong) return
	const count = parseInt(totalCountStrong.textContent)
	const countTitle = createElement('strong', ['total-product-count-title'], language === 'cs' ? 'Nalezeno: ' : 'Nájdených: ')
	if (count === 0) {
		totalProductCount.innerText = language === 'cs' ? 'Žádné produkty' : 'Žiadne produkty'
	} else if (count === 1) {
		countTitle.textContent = language === 'cs' ? 'Nalezen: ' : 'Nájdený: '
		totalProductCount.innerText = totalProductCount.innerText.replace(' položek celkem', ' produkt')
	} else if (count > 1 && count < 5) {
		countTitle.textContent = language === 'cs' ? 'Nalezeny: ' : 'Nájdené: '
		totalProductCount.innerText = totalProductCount.innerText.replace(' položek celkem', ' produkty')
	} else {
		totalProductCount.innerText = totalProductCount.innerText.replace(' položek celkem', ' produktů')
	}
	if (count > 0) {
		totalProductCount.prepend(countTitle)
	}
}

const changeTextInFilterBtn = () => {
	const unveilBtn = document.querySelector('.filters-unveil-button-wrapper .btn-default.unveil-button')
	if (unveilBtn) {
		unveilBtn.textContent = window.language === 'cs' ? 'Filtrace' : 'Filtrácia'
		unveilBtn.addEventListener('click', () => {
			unveilBtn.classList.toggle('active')
			unveilBtn.textContent = window.language === 'cs' ? 'Filtrace' : 'Filtrácia'
		})
		unveilBtn.setAttribute('data-text', window.language === 'cs' ? 'Filtrace' : 'Filtrácia')
	}
}

const changeTextInPagination = (textToTop, textToLoader) => {
	const pagination = document.querySelector('.pagination-wrapper')

	if (pagination) {
		const paginationTop = pagination.querySelector('.pagination-top strong.js-scroll-top')
		const paginationLoaderBtn = pagination.querySelector('.pagination-loader .btn')
		if (paginationTop) paginationTop.textContent = textToTop
		if (paginationLoaderBtn) paginationLoaderBtn.textContent = textToLoader
	}
}
const fixPaginationScroll = () => {
	let scrollProductsOffset = 119

	document.addEventListener('ShoptetPagePaginationUsed', () => {
		document.addEventListener('ShoptetDOMContentLoaded', () => {
			setTimeout(() => {
				const target = document.querySelector('.content-wrapper-in')
				if (!target) return

				const targetPosition = target.getBoundingClientRect().top + window.scrollY - scrollProductsOffset
				window.scrollTo({ top: targetPosition, behavior: 'smooth' })
				// target.scrollIntoView({ behavior: 'smooth' })
				// console.log('scrolled')
			}, 500)
		})
	})
}
export {
	addTitleToFiltersBoolean,
	makeFilterTitlesClickable,
	createShowSubcategoriesButton,
	moveCategoryBannersIntoProducts,
	categoryHead,
	handleCheckedFilters,
	addIDToDescription,
	createCategoryWrapper,
	handleTopProducts,
	handleTotalProductCount,
	changeTextInFilterBtn,
	changeTextInPagination,
	fixPaginationScroll,
}
